<script>
    import './entrypoint.scss';
    import Router from 'svelte-spa-router'
    import active from 'svelte-spa-router/active'
    import {sendPageviewEvent} from './util/gtm'
    import Form from './Form.svelte'
    import Submit from './Submit.svelte'
    import Confirm from './Confirm.svelte'
    import Confirmed from './Confirmed.svelte'
    import Documents from './Documents.svelte'
    import FourOFour from './404.svelte'
    import Header from './Header.svelte'

    const routes = {
        '/': Form,
        '/submit': Submit,
        '/confirm': Confirm,
        '/confirmed': Confirmed,
        '/documents': Documents,
        '*': FourOFour
    }

    function routeLoaded(event) {
        // console.log('routeLoaded event', event);
        sendPageviewEvent(event.detail.location);
    }

    function toggleMenu(event) {
        const activeClass = 'is-active';
        let menu = document.getElementById('navbarBasicExample');
        let classes = menu.classList;
        let isActive = classes.contains(activeClass);
        if (isActive) {
            classes.remove(activeClass);
        } else {
            classes.add(activeClass);
        }
    }

</script>

<style>
    div.container {
        padding: 10px;
    }

    a.navbar-item {
        background-color: #eeeeee;
        text-decoration: none;
        color: #032f62;
    }

    a.navbar-item:visited {
        color: #032f62;
    }

    a.navbar-item:hover {
        background-color: #ffffff;
    }

    a.navbar-item.active {
        background-color: #eeeeee;
        font-weight: 500;
    }

    .hide {
        display: none;
    }

</style>

<div class="container">
    <Header/>
    <div class="bd-content">
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" on:click={toggleMenu} >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div id="navbarBasicExample" class="navbar-menu">
                <div class="navbar-start">
                    <a class="navbar-item" use:active href="#/">Bestelformulier</a>
                    <a class="navbar-item" use:active href="#/documents">Documenten</a>
                    <a class="navbar-item active hide" use:active href="#/">.</a>
                </div>
            </div>
        </nav>
    </div>
    <Router {routes} on:routeLoaded={routeLoaded}/>
</div>